import { useLazyQuery, useMutation, useQuery } from '@apollo/client/react';
import { Box } from '@mui/material';
import moment from 'moment';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { CustomButton } from '../../../components/customButton/CustomButton';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { DELETE_VISITAS_CERO } from '../../../data/graphQL/mutations/ControlVisita/deleteVisitasCero';
import GET_TIPO_PROFESIONAL_USUARIO_LOGGEADO from '../../../data/graphQL/queries/ControlVisitas/getTipoProfByUserLogged';
import { GET_PERMISO_NUEVA_VISITA } from '../../../data/graphQL/queries/MisVisitas/getPermisoNuevaVisita';
import { handleClickNueva } from '../constants/handleNuevaVisita';
import '../controlVisitaDetalle.scss';
import { useGetColumns } from "../hooks/useGetColumns";
import { useGetColumnsCoordinador } from "../hooks/useGetColumnsCoordinador";
import { useGetRows } from "../hooks/useGetRows";
import { CabeceraControlVisita } from "./CabeceraControlVisita";
import { NovedadesVisitaModal } from './NovedadesVisitaModal';
export const TIPO_PROFESIONAL_MEDICO_ID = 1;
export const TIPO_PROFESIONAL_NUTRICIONISTA_ID = 3;

const novedadesSettingsIntialState = {
    open: false,
    idVisita: null
};

export const ControlVisitaDetalleContent = ({ setChildrenAction }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const [novedadesSettings, setNovedadesSettings] = useState(novedadesSettingsIntialState);

    const datosCabecera = useMemo(() => { return { ...location.state } }, [location.state]);
    const { idEvaluacion, idProfesional, idTipoProfesional, idFrecuencia, idFiguraProfesional, mes, anio, fechaDesde, fechaHasta } = datosCabecera;

    const [mostrarBotonNuevaVisita, setMostrarBotonNuevaVisita] = useState(false);
    const [userLoggedMedicoONutri, setUserLoggedMedicoONutri] = useState(false);

    const [deleteVisitasCero] = useMutation(DELETE_VISITAS_CERO, { fetchPolicy: 'no-cache' });

    const [getPermisoNuevaVisita, { data: dataPermisoNuevaVisita, loading: loadingPermiso }] = useLazyQuery(GET_PERMISO_NUEVA_VISITA, {
        fetchPolicy: 'no-cache'
    });

    const { data: dataUserLogged } = useQuery(GET_TIPO_PROFESIONAL_USUARIO_LOGGEADO, {
        fetchPolicy: 'no-cache'
    });

    useEffect(() => {
        if (!loadingPermiso)
            getPermisoNuevaVisita({
                variables: {
                    input: {
                        idEvaluacion: idEvaluacion,
                        idTipoProfesional: idTipoProfesional,
                        fechaDesde: moment(`${datosCabecera?.mes} ${datosCabecera?.anio}`, 'MMMM YYYY').startOf('month').format('DD/MM/YYYY'),
                        fechaHasta: moment(`${datosCabecera?.mes} ${datosCabecera?.anio}`, 'MMMM YYYY').endOf('month').format('DD/MM/YYYY')
                    }
                }
            });
    }, []);

    useEffect(() => {
        if (!dataPermisoNuevaVisita) return;

        setMostrarBotonNuevaVisita(dataPermisoNuevaVisita.permisoNuevaVisitaControl);
    }, [dataPermisoNuevaVisita]);

    useEffect(() => {
        if (!dataUserLogged) return;
        const tipoProfesional = dataUserLogged.profesionalByIdUsuario?.idTipoProfesionalNavigation?.descripcion || '';
        setUserLoggedMedicoONutri(tipoProfesional.toLowerCase() === 'medico' || tipoProfesional.toLowerCase() === 'nutricionista');
    }, [dataUserLogged]);

    const {
        reload,
        rows,
        rowsCoordinador,
        setRows,
        loading,
        totalCount,
    } = useGetRows({ idEvaluacion, idProfesional, idTipoProfesional, idFrecuencia, mes, anio, fechaDesde, fechaHasta, idFiguraProfesional });

    const resetNovedadesSettings = () => {
        setNovedadesSettings(novedadesSettingsIntialState);
    }

    const handleOpenNovedadesModal = (idVisita) => {
        setNovedadesSettings({
            open: true,
            idVisita
        });
    }

    const columns = useGetColumns({
        datosCabecera,
        reload,
        idTipoProfesional,
        handleOpenNovedadesModal,
        userLoggedMedicoONutri
    });

    const columnsCoordinador = useGetColumnsCoordinador({ datosCabecera });

    const handleClickNuevaVisita = async (datosCabecera, navigate) => {
        await deleteVisitasCero({ variables: { idEvaluacion, idProfesional, idTipoProfesional, idFiguraProfesional, idFrecuencia } });
        handleClickNueva(datosCabecera, navigate);
    }

    useEffect(() => {
        setChildrenAction(() =>
            <div className='top-buttons'>
                {mostrarBotonNuevaVisita && <CustomButton
                    className='margin-right'
                    onClick={() => handleClickNuevaVisita(datosCabecera, navigate)}
                >
                    Nueva Visita
                </CustomButton>}
            </div >
        );

    }, [setChildrenAction, datosCabecera, mostrarBotonNuevaVisita]);


    return <>
        <CabeceraControlVisita data={datosCabecera} />
        <Box>
            <DataGridGenerico
                key='visitas-profesional'
                columns={columns}
                rows={rows}
                autoMaxWidth
                totalCount={totalCount}
                toolbar={false}
                loading={loading}
            />
        </Box>
        <Box sx={{ marginTop: '12px' }}>
            <div style={{ paddingBottom: '10px' }}><strong>Consulta del coordinador</strong></div>
            <DataGridGenerico
                key='visitas-coordinador'
                columns={columnsCoordinador}
                rows={rowsCoordinador}
                autoMaxWidth
                totalCount={totalCount}
                toolbar={false}
                loading={loading}
            />
        </Box>
        {novedadesSettings.open && <NovedadesVisitaModal
            novedadesSettings={novedadesSettings}
            resetNovedadesSettings={resetNovedadesSettings}
        />}
    </>
}